export enum Multiplicities {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE',
  CHECK_ALL = 'CHECK_ALL',
}
